import { EnumPaymentMethod } from './Generated';
import { type Nullable, type SelectOption } from '@synqo/frontend-component-library';

export function getEnumPaymentMethodLabel(value: EnumPaymentMethod) {
    switch (value) {
        case EnumPaymentMethod.Cash:
            return 'Barzahlung';
        case EnumPaymentMethod.Card:
            return 'EC';
        case EnumPaymentMethod.Cheque:
            return 'Scheck';
        case EnumPaymentMethod.Transfer:
            return 'Überweisung (Rechnung)';
        case EnumPaymentMethod.Debit:
            return 'Lastschrift';
        case EnumPaymentMethod.PayPal:
            return 'PayPal';
        default:
            return 'Nicht definiert';
    }
}

export const paymentMethodOptions: SelectOption<Nullable<EnumPaymentMethod>>[] = [
    {
        name: 'transfer',
        label: getEnumPaymentMethodLabel(EnumPaymentMethod.Transfer),
        value: EnumPaymentMethod.Transfer,
    },
    { name: 'debit', label: getEnumPaymentMethodLabel(EnumPaymentMethod.Debit), value: EnumPaymentMethod.Debit },
    { name: 'cash', label: getEnumPaymentMethodLabel(EnumPaymentMethod.Cash), value: EnumPaymentMethod.Cash },
    { name: 'card', label: getEnumPaymentMethodLabel(EnumPaymentMethod.Card), value: EnumPaymentMethod.Card },
    { name: 'paypal', label: getEnumPaymentMethodLabel(EnumPaymentMethod.PayPal), value: EnumPaymentMethod.PayPal },
    { name: 'cheque', label: getEnumPaymentMethodLabel(EnumPaymentMethod.Cheque), value: EnumPaymentMethod.Cheque },
];

export function isDirect(paymentMethod: EnumPaymentMethod) {
    return paymentMethod === EnumPaymentMethod.Cash || paymentMethod === EnumPaymentMethod.Card;
}
